<template>
  <Page class="skill-page" :pagination="`${page}/${total_pages}`">
    <template #content>
      <span class="page-title">Motivation</span>
      <div class="content-wrapper">
        <div class="content-block">
          <div class="content-title">PROFIL DU TALENT :</div>
          <div class="content" v-text="motivationTexts[motivationStyle].analysis" />
        </div>
        <div class="content-block">
          <div class="content-title">LES AVANTAGES :</div>
          <div class="content" v-text="motivationTexts[motivationStyle].plus" />
        </div>
        <div class="content-block">
          <div class="content-title">LES INCONVÉNIENTS :</div>
          <div
            class="content"
            v-text="motivationTexts[motivationStyle].minus"
          />
        </div>
      </div>
    </template>
  </Page>
  <Page :pagination="`${page + 1}/${total_pages}`">
    <template #content>
      <span class="page-title">Motivation</span>
      <div class="content-wrapper">
        <div class="content-block">
          <div class="content-title">Définition :</div>
          <div
            class="content"
            v-text="
              `La motivation reflète les raisons qui poussent le talent à s'engager dans une tâche et sa perception de sa capacité à réussir.`
            "
          />
        </div>
        <div class="content-block">
          <div class="content-title">Son importance :</div>
          <div class="content">
            <div class="avantage">
              <div class="icon-container">
                <i class="yuzu-icon accurate" />
              </div>
              <p>Développer des méthodes d'acquisition efficaces</p>
            </div>
            <div class="avantage">
              <div class="icon-container">
                <i class="yuzu-icon glasses" />
              </div>
              <p
                v-text="
                  `Renforcer l'autonomie et la capacité d'adaptation face à des environnements changeants`
                "
              />
            </div>
            <div class="avantage">
              <div class="icon-container">
                <i class="yuzu-icon card-people-plus" />
              </div>
              <p>
                Stimuler une progression continue pour évoluer dans sa carrière
              </p>
            </div>
          </div>
        </div>
        <div class="content-block">
          <div class="content-title">
            3 questions pour approfondir cette évaluation :
          </div>
          <div class="content">
            <ol>
              <li
                v-for="(question, index) in motivationTexts[motivationStyle]
                  .questions"
                :key="index"
                v-text="question"
              />
            </ol>
          </div>
        </div>
      </div>
    </template>
  </Page>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useModulesStore } from "@/stores/modules.js";
import Page from "../Page.vue";

const { modules } = useModulesStore();

const props = defineProps({
  motivationStyle: {
    type: String,
    required: true,
  },
  index: {
    type: Number,
    required: true,
  },
  total_pages: {
    type: Number,
    required: true,
  },
});

const page = computed(() => props.index * 2 + 3);

const motivationTexts = computed(() => modules.find((elt) => elt.id === "motivation")?.result_wordings);
</script>
